var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fix-header",attrs:{"id":"app"}},[_c('v-header'),_vm._v(" "),_c('v-leftbar'),_vm._v(" "),_c('v-content'),_vm._v(" "),_c('footer',{staticClass:"footer text-center hidden-xs"},[_vm._v(" "+_vm._s(_vm.date)+" © linkingvision.com ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e941c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/h5s.vue
// module id = null
// module chunks = 